<template>
  <div class="renwu">
    <!-- 医生排班控制 -->
    <div class="top">
      <DatePicker @on-change="searchDateChange" v-model="searchDate" format="yyyy-MM-dd" separator=" 至 " type="daterange" placeholder="请选择筛选条件"></DatePicker>
      <Button class="title-btn" type="success" @click="toAddPlan" ghost>新增医生排班</Button>
    </div>
    <div class="table-cont">
      <Table :loading="doctorPaibanloading" row-key="id" :row-class-name="planRowClassName" :columns="planCols" :data="planData" border>
        <template slot-scope="{ row, index }" slot="action">
          <Button type="info" size="small" v-if="row.isPlan" style="margin-right: 5px" @click="editPlan(row)">修改</Button>
          <Button type="error" size="small" v-if="!row.isAP" @click="deletePlan(row)">删除</Button>
        </template>
      </Table>
    </div>

    <Modal class="ivumodal" footer-hide width="1000" v-model="singleAdd" :title="planForm.title || '新增医生排班'">
      <div>
        <Form :model="planForm" :label-width="130" class="planForm">
          <FormItem label="排班日期">
            <DatePicker :disabled="planForm.planDateDisabled" class="planFormInput" format="yyyy-MM-dd" separator=" 至 " v-model="planForm.planDate" type="daterange" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem label="上午">
            <!--  <Input class="planFormInput" v-model="AmNum" placeholder=""></Input> -->
            <Button type="info" size="small" @click="openDoctorModal('Am')">医生<Icon type="md-add"></Icon></Button>
            <div style="margin-top: 10px" v-for="(item, index) in AmDoctors" :key="index">
              <div style="width: auto; display: inline-block; vertical-align: top">
                <Input class="planFormInput" readonly v-model="item.doctorName" placeholder="医生名字"></Input>
              </div>
              <div style="width: auto; display: inline-block; vertical-align: top">
                <Input class="planFormInput" readonly v-model="item.organizationName" placeholder=""></Input>
              </div>
              <div style="margin-left: 10px; width: 80px; display: inline-block">
                <Input class="planFormInput" readonly v-model="item.departName" placeholder="">
                <span slot="append" class="planFormInputAppend"><Button @click="deletePaibanFormAppend(item.doctorId,index,'am')" type="info">删除</Button></span>
                </Input>
              </div>
            </div>
          </FormItem>
          <FormItem label="下午">
            <!-- <Input class="planFormInput" v-model="PmNum" placeholder=""></Input> -->
            <Button type="info" size="small" @click="openDoctorModal('Pm')">医生<Icon type="md-add"></Icon></Button>
            <div style="margin-top: 10px" v-for="(item, index) in PmDoctors" :key="index">
              <div style="width: auto; display: inline-block; vertical-align: top">
                <Input class="planFormInput" readonly v-model="item.doctorName" placeholder=""></Input>
              </div>
              <div style="width: auto; display: inline-block; vertical-align: top">
                <Input class="planFormInput" readonly v-model="item.organizationName" placeholder=""></Input>
              </div>
              <div style="margin-left: 10px; width: 80px; display: inline-block">
                <Input class="planFormInput" readonly v-model="item.departName" placeholder="">
                <span slot="append" class="planFormInputAppend"><Button @click="deletePaibanFormAppend(item.doctorId,index,'pm')" type="info">删除</Button></span>
                </Input>
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="singleAdd = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="saveSinglePaibanData">保存</Button>
      </div>
      <Spin size="large" fix v-if="modelLoading"></Spin>
    </Modal>

    <Modal class="ivumodal" footer-hide width="1000" v-model="doctorShow" title="医生信息">
      <!--  <div>
        <Input class="planFormInput" v-model="doctorName" placeholder=""></Input>
      </div> -->
      <!-- <Input v-model="doctorName" @on-clear="searchDoctorList()" @on-enter="searchDoctorList(1)" placeholder="请输入医生名称进行搜索" clearable class="doctor-input">
      <Icon type="ios-search" slot="prefix" />
      </Input> -->
      <Table :loading="doctorloading" @on-selection-change="selectChange" @on-select="selectDoctor" height="600" draggable stripe :columns="columns" :data="doctorData"></Table>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="doctorShow = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="addDoctorFormAppend">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getDoctorList,
  getDoctor,
  saveDoctors,
  updateDoctors,
  deleteDoctors,
} from "../servers/api";

export default {
  name: "jihua",
  data() {
    return {
      doctorloading: false,
      doctorPaibanloading: false,
      doctorData: [],
      id: "",
      AmNum: "",
      PmNum: "",
      doctorName: "",
      doctorShow: false,
      singleAdd: false,
      reservationModal: {
        open: false,
        input: "",
        timeId: undefined,
        timeIndex: undefined,
      },
      searchDate: "",
      planForm: { title: "", planDate: "" },
      planTimeArr: [],
      AmDoctors: [],
      PmDoctors: [],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "医生名称",
          width: 250,
          align: "center",
          key: "doctorName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "性别",
          width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "gender",
          render: (h, params) => {
            let name = "";
            if (params.row.gender == 1) {
              name = "男";
            } else if (params.row.gender == 2) {
              name = "女";
            }
            return h(
              "div",
              {
                style: {
                  "font-size": "13px",
                },
              },
              name
            );
          },
        },
        {
          title: "年龄",
          width: 200,
          align: "center",
          key: "age",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "部门名称",
          align: "center",
          width: 200,
          ellipsis: true,
          sortable: true,
          key: "departName",
        },
        {
          title: "医院名称",
          align: "center",
          width: 300,
          ellipsis: true,
          sortable: true,
          key: "organizationName",
        },
      ],
      doctorCols: [
        {
          title: "医生名字",
          width: 200,
          align: "center",
          key: "doctorName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "医院名称",
          width: 200,
          align: "center",
          key: "organizationName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "部门名称",
          width: 200,
          align: "center",
          key: "departName",
          ellipsis: true,
          sortable: true,
        },
      ],
      paibanTimeArr: [
        {
          label: "上午",
          id: "1",
        },
        {
          label: "下午",
          id: "2",
        },
      ],
      allBookingTime: [],
      allOrgReservation: [],
      planCols: [],
      planData: [],
      modelLoading: false,
      flag: "",
      selectList: [],
      lastSelectList: [],
      afterEnterSelectList: [],
      singleDoctor: {},
      enter: false,
      first: true,
    };
  },
  methods: {
    searchDoctorList(index) {
      if (index) {
        this.enter = true;
        this.afterEnterSelectList = JSON.parse(JSON.stringify(this.selectList));
      }
      this.MgetDoctor(this.flag);
    },
    selectChange(item) {
      //表格select选中
      this.lastSelectList = JSON.parse(JSON.stringify(this.selectList));
      this.selectList = item;
      this.first = false;
    },
    selectDoctor(selection, row) {
      this.singleDoctor = row;
      this.first = false;
    },
    saveSinglePaibanData() {
      if (this.planForm.title == "新增医生排班") {
        if (this.planForm.planDate) {
          let planDateStrArr = [];
          let submitForm = {};
          this.planForm.planDate.forEach((item) => {
            let date = new Date(item);
            planDateStrArr.push(
              date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate()
            );
          });
          submitForm.startDate = planDateStrArr[0];
          submitForm.endDate = planDateStrArr[1];
          let str = "";
          this.AmDoctors.forEach((item) => {
            str = str + item.doctorId + ",";
          });
          submitForm.monDoctorsAccountIds = str;
          let str2 = "";
          this.PmDoctors.forEach((item) => {
            str2 = str2 + item.doctorId + ",";
          });
          submitForm.aftDoctorsAccountIds = str2;
          saveDoctors(submitForm).then(() => {
            this.$Message.success("保存成功");
            this.singleAdd = false;
            this.searchDateChange();
          });
        } else {
          this.$Message.error("请选择排班日期");
        }
      } else {
        let submitForm = {};
        submitForm.id = this.id;
        let str = "";
        this.AmDoctors.forEach((item) => {
          str = str + item.doctorId + ",";
        });
        submitForm.monDoctorsAccountIds = str;
        let str2 = "";
        this.PmDoctors.forEach((item) => {
          str2 = str2 + item.doctorId + ",";
        });
        submitForm.aftDoctorsAccountIds = str2;
        updateDoctors(submitForm).then((res) => {
          if (res.data.code == 1) {
            this.$Message.success("修改成功");
            this.singleAdd = false;
            this.searchDateChange();
          }
        });
      }
    },
    addDoctorFormAppend() {
      if (this.flag == "Am") {
        this.AmDoctors = this.selectList;
      }
      if (this.flag == "Pm") {
        this.PmDoctors = this.selectList;
      }
      this.doctorShow = false;
    },
    deletePaibanFormAppend(id, index, str) {
      if (str == "am") {
        this.AmDoctors.splice(index, 1);
      }
      if (str == "pm") {
        this.PmDoctors.splice(index, 1);
      }
    },
    openDoctorModal(str) {
      this.doctorShow = true;
      this.flag = str;
      this.doctorName = "";
      this.doctorloading = true;
      this.MgetDoctor(str);
    },
    editPlan(rowData) {
      this.planForm = {};
      this.id = rowData.id;
      this.planForm.title = "修改医生排班";
      this.planForm.planDate = [rowData.date, rowData.date];
      this.planForm.planDateDisabled = true;
      if (rowData.children[0].children) {
        this.AmDoctors = JSON.parse(
          JSON.stringify(rowData.children[0].children)
        );
      }
      if (rowData.children[1].children) {
        this.PmDoctors = JSON.parse(
          JSON.stringify(rowData.children[1].children)
        );
      }
      this.singleAdd = true;
    },
    toAddPlan() {
      this.planForm = {};
      this.singleAdd = true;
      this.AmDoctors = [];
      this.PmDoctors = [];
      this.planForm.title = "新增医生排班";
    },
    planRowClassName(row, index) {
      return "table-warning-row";
    },
    initTimeReservation(allOreservationArr) {
      this.planTimeArr.forEach((item, index) => {
        let needChange = false;
        if (item.children && item.children.length) {
          item.children.forEach((childItem) => {
            if (
              allOreservationArr.filter(
                (item) => item.idOrgReservation === childItem.reservationId
              ).length < 1
            ) {
              item.idOrgReservation = "";
              needChange = true;
            }
          });
        }
        if (needChange) {
          this.planTimeArr.splice(index, 1, item);
        }
      });
    },
    deletePlan(rowData) {
      this.$Modal.confirm({
        title: "提醒",
        content: "<p>确认要删除么</p>",
        onOk: () => {
          if (rowData.isPlan) {
            deleteDoctors({ id: rowData.id }).then((res) => {
              if (res.data.code == 1) {
                this.planData = this.planData.filter(
                  (item) => item.id !== rowData.id
                );
              }
            });
          } else {
            if (rowData.type == 1) {
              deleteDoctors({
                id: rowData.planId,
                monDoctorsAccountIds: rowData.doctorId,
                type: 1,
              }).then((res) => {
                if (res.data.code == 1) {
                  /* let dataInArr = this.planData.find(
                    (item) => item.id === rowData.planId
                  );
                  console.log(dataInArr, "dataInArrdataInArr");
                  dataInArr.children[0] = dataInArr.children[0].children.filter(
                    (item) => item.doctorId !== rowData.doctorId
                  );
                  console.log(
                    dataInArr.children[0],
                    "dataInArrdataInArr.children[0]"
                  ); */
                  this.searchDateChange();
                }
              });
            } else {
              deleteDoctors({
                id: rowData.planId,
                aftDoctorsAccountIds: rowData.doctorId,
                type: 2,
              }).then((res) => {
                if (res.data.code == 1) {
                  this.searchDateChange();
                }
              });
            }
          }
        },
        onCancel: () => {
          this.$Message.info("您取消了删除操作");
        },
      });
    },
    searchDateChange() {
      // this.MgetDoctorList();
      let submitForm = {};
      if (this.searchDate && this.searchDate.length && this.searchDate[0]) {
        let planDateStrArr = [];
        this.searchDate.forEach((item) => {
          let date = new Date(item);
          planDateStrArr.push(
            date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
          );
        });
        submitForm.startDate = planDateStrArr[0];
        submitForm.endDate = planDateStrArr[1];
      }
      this.doctorPaibanloading = true;
      getDoctorList(submitForm).then((response) => {
        this.doctorPaibanloading = false;
        let tempData = [];
        response.data.data.forEach((item) => {
          let temp = {};
          temp.organizationId = item.organizationId;
          temp.showName = item.showName;
          temp.date = item.date;
          temp.whetherToOpen = item.whetherToOpen;
          temp.children = [];
          let Am = { showName: "上午" };
          let Pm = { showName: "下午" };
          temp.children.push(Am);
          temp.children.push(Pm);
          temp.children._showChildren = true;
          temp.children[0].children = item.morningDoctorList;
          temp.children[1].children = item.afternoonDoctorList;
          temp.id = item.id;
          temp.morningIdDoctor = item.morningIdDoctor;
          temp.afternoonIdDoctor = item.afternoonIdDoctor;
          temp.day = item.day;
          temp._showChildren = true;
          temp.children[0].id = item.id + item.morningIdDoctor + "11";
          temp.children[1].id = item.id + item.afternoonIdDoctor + "22";
          temp.children[0]._showChildren = true;
          temp.children[1]._showChildren = true;
          temp.children[0].isAP = true;
          temp.children[1].isAP = true;
          temp.isPlan = true;
          temp.disable = 0;
          tempData.push(temp);
        });
        this.planData = tempData;
      });
    },
    MgetDoctor(str) {
      getDoctor({ doctorName: this.doctorName }).then((response) => {
        if (response.data.code == 1) {
          this.doctorloading = false;
          this.doctorData = response.data.data;
          if (this.planForm.title == "修改医生排班") {
            //修改医生排班 将现有的医生默认设置已选
            if (str == "Am") {
              for (let j = 0; j < this.doctorData.length; j++) {
                for (let i = 0; i < this.AmDoctors.length; i++) {
                  if (
                    this.doctorData[j].doctorId == this.AmDoctors[i].doctorId
                  ) {
                    this.doctorData[j]._checked = true;
                    break;
                  }
                }
              }
            } else {
              for (let j = 0; j < this.doctorData.length; j++) {
                for (let i = 0; i < this.PmDoctors.length; i++) {
                  if (
                    this.doctorData[j].doctorId == this.PmDoctors[i].doctorId
                  ) {
                    this.doctorData[j]._checked = true;
                    break;
                  }
                }
              }
            }
          }
        }
      });
    },
    MgetDoctorList() {
      this.doctorPaibanloading = true;
      getDoctorList({}).then((response) => {
        // this.planData = response.data.data;
        this.doctorPaibanloading = false;
        let tempData = [];
        response.data.data.forEach((item) => {
          let temp = {};
          temp.organizationId = item.organizationId;
          temp.showName = item.showName;
          temp.date = item.date;
          temp.whetherToOpen = item.whetherToOpen;
          temp.children = [];
          let Am = { showName: "上午" };
          let Pm = { showName: "下午" };
          temp.children.push(Am);
          temp.children.push(Pm);
          temp.children._showChildren = true;
          temp.children[0].children = item.morningDoctorList;
          temp.children[1].children = item.afternoonDoctorList;
          temp.id = item.id;
          temp.morningIdDoctor = item.morningIdDoctor;
          temp.afternoonIdDoctor = item.afternoonIdDoctor;
          temp.day = item.day;
          temp._showChildren = true;
          temp.children[0].id = item.id + item.morningIdDoctor + "11";
          temp.children[1].id = item.id + item.afternoonIdDoctor + "22";
          temp.children[0]._showChildren = true;
          temp.children[1]._showChildren = true;
          /* if (temp.children[0].children) {
            temp.children[0].children.forEach((item) => {
              item.id = item.planId + item.doctorId;
            });
          }
          if (temp.children[1].children) {
            temp.children[1].children.forEach((item) => {
              item.id = item.planId + item.doctorId;
            });
          } */

          /*temp.children[0]._showChildren = true;
          temp.children[1]._showChildren = false; */
          temp.children[0].isAP = true;
          temp.children[1].isAP = true;
          temp.isPlan = true;
          temp.disable = 0;
          tempData.push(temp);
        });
        this.planData = tempData;
      });
    },
  },
  mounted() {
    this.planCols = [
      {
        title: "日期",
        key: "showName",
        tree: true,
        render: (h, params) => {
          return h("span", [
            h(
              "span",
              {
                style: {
                  marginRight: "5px",
                },
              },
              params.row.showName
            ),
          ]);
        },
      },
      {
        title: "所属科室",
        align: "center",
        width: 180,
        ellipsis: true,
        sortable: true,
        key: "departName",
      },
      {
        title: "职务",
        align: "center",
        width: 200,
        ellipsis: true,
        sortable: true,
        key: "positionName",
      },
      {
        title: "性别",
        width: 70,
        align: "center",
        key: "gender",
        ellipsis: true,
        sortable: true,
        render: (h, params) => {
          let a = "";
          if (params.row.gender == 1) {
            a = "男";
          } else if (params.row.gender == 2) {
            a = "女";
          } else {
            a = "";
          }
          return h("div", {}, a);
        },
      },
      {
        title: "年龄",
        align: "center",
        width: 70,
        ellipsis: true,
        sortable: true,
        key: "age",
      },
      {
        title: "机构名称",
        align: "center",
        width: 230,
        ellipsis: true,
        sortable: true,
        key: "organizationName",
      },
    ];
    this.planCols.push({
      title: " ",
      slot: "action",
      width: 150,
      align: "right",
    });
    this.MgetDoctorList();
    /* getDoctor({}).then((response) => {
      if (response.data.code == 1) {
        this.doctorData = response.data.data;
        console.log(this.doctorData, "this.doctorData");
      }
    }); */
  },
};
</script>

<style lang="scss" scoped type="text/scss">
@import "../font/iconfont.css";
@import "../css/conmmon.scss";
.ivumodal /deep/ {
  font-family: SimHei;
  color: #7f7f7f;
  .title {
    color: #f59a23;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 15px;
  }
}
.doctor-input {
  width: 250px;
  margin-bottom: 20px;
}
.ivu-table .table-warning-row td {
  background-color: #2db7f5;
  color: #fff;
}
.planForm .ivu-form-item {
  margin-bottom: 24px;
}
.planForm .planFormInput {
  width: 220px;
}
.planFormInputAppend {
  color: #ff0000;
}

.renwu {
  font-family: SimHei;
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .title-btn {
    vertical-align: top;
    float: right;
    margin-left: 10px;
  }
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin-top: 35px;
    margin-bottom: 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jianhou/doctorpaiban.vue